/*
  Gemeinsame Export-Format-Konstanten für Toolbar und Export-Dialog.
*/

export const EXPORT_FORMATS = Object.freeze({
  PDF: "pdf",
  EXCEL: "excel",
});

export function normalizeExportFormat(value) {
  return value === EXPORT_FORMATS.EXCEL ? EXPORT_FORMATS.EXCEL : EXPORT_FORMATS.PDF;
}
